import { useTranslation } from 'react-i18next'
import { ModalPage } from 'components/layout'

const Home = () => {
  const { t } = useTranslation()

  return <ModalPage>{t('pages.home.title')}</ModalPage>
}

export { Home }
